<template>
  <div id="goods-sku">
    <!-- sku弹窗 van-sku v-model="showSku" :goods-id="goodsId"
      :hide-stock="sku.hide_stock"
      :message-config="messageConfig" :quota="quota"
      :quota-used="quotaUsed"  @buy-clicked="onBuyClicked"
      @add-cart="onAddCartClicked"  :initial-sku="initialSku"-->

    <van-sku
      ref="skuRef"
      v-model="localShowSku"
      :initial-sku="initialSku ? initialSku : null"
      :sku="sku"
      :goods="
        goods.picture
          ? goods
          : { picture: require('@/assets/img/qietu/zz_default.png') }
      "
      :hide-stock="hideStock"
      :show-add-cart-btn="false"
      :class="['meeting-sku-pannel', hideStepper ? 'hide-stepper' : '']"
      :buy-text="buyText"
      @buy-clicked="buyGoods"
      @sku-selected="skuSelected"
    >
      <!-- 自定义 sku-header-price sku-header-extra -->
      <template #sku-header-extra="props">
        <span
          class="header-show-selected-count"
          v-if="props && props.selectedSkuComb"
          >{{ props.selectedNum }}个</span
        >
      </template>
      <!-- 课程隐藏购买数量 -->
      <template #sku-stepper v-if="hideStock || goodsType === 'meeting'">
        <span></span>
      </template>
      <template #sku-actions-top="props">
        <div class="extra-tips">
          <!-- 如需审核则提示 -->
          <span
            v-if="
              props && props.selectedSkuComb && props.selectedSkuComb.isExamine
            "
            >【需要审核】</span
          >
          <span v-if="props && props.selectedSkuComb">
            {{ selectedText.replace(" 已选：", "") }}</span
          >
          <!-- 如有描述则显示 -->
          <span
            v-if="props && props.selectedSkuComb && props.selectedSkuComb.desc"
          >
            {{ props.selectedSkuComb.desc }}</span
          >
        </div>
      </template>
    </van-sku>
  </div>
</template>

<script>
export default {
  name: "gooodsSku",
  props: [
    "showSku",
    "sku",
    "initialSku",
    "goods",
    "buyText",
    "handleBuy",
    "updateSkuPannelStatus",
    "hideStepper",
    "hideStock", // 课程隐藏购买数量和库存
    "goodsType",
  ],
  watch: {
    localShowSku(newValue) {
      // 修改父组件中的值
      this.$emit("updateSkuPannelStatus", newValue);
    },
  },

  data() {
    return {
      selectedText: "",
      localShowSku: false,
      selectedId: "",
    };
  },
  created() {
    // vant sku目前仅支持中文，修改默认提示文本,再"已选"后添加中文冒号
    this.$vantMessages["zh-CN"].vanSku.selected = "已选：";
    this.localShowSku = this.showSku;
  },
  methods: {
    skuSelected({ skuValue, selectedSku, selectedSkuComb }) {
      this.selectedText = this.$refs.skuRef.selectedText;
    },
    // 转换selectedSkuComb 现在在报名按钮上方
    formatGoodsInfo(skuData) {
      // this.$refs.skuRef.getSkuData()
    },
    buyGoods(skuData) {
      // selectedText自定义属性，保存所选规格对应的文本信息
      skuData.selectedText = this.selectedText;
      // pictureUrl自定义属性，保存商品默认图片文本信息
      skuData.pictureUrl = this.goods.picture;
      console.log("goodsSku", skuData, this.goods);
      this.$emit("handleBuy", skuData);
    },
  },
};
</script>

<style lang="scss" scoped>
#goods-sku {
  .meeting-sku-pannel {
    ::v-deep .van-hairline--bottom,
    ::v-deep .van-sku-stepper-stock {
      margin-left: 25px;
      margin-right: 25px;
    }

    ::v-deep .van-hairline--bottom::after {
      border-bottom-width: 0px;
    }

    ::v-deep .van-sku-header {
      .van-sku-header__img-wrap {
        // margin-top: 18px;
        margin-right: 15px;
        width: 100px;
        // height: 56px;
        background: #d8d8d8;
        border-radius: 8px;
      }

      .van-sku-header__goods-info {
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: flex-start;
        padding-top: 21px;

        // align-content: center;
        .van-sku__goods-price {
          width: 100%;

          .van-sku__price-symbol {
            font-size: 12px;
            color: #ff3d3d;
          }

          .van-sku__price-num {
            font-size: 16px;
            color: #ff3d3d;
          }
        }

        .van-sku-header-item {
          // width: 70%;
          font-size: 13px;
          color: #999;
          // margin-top: 10px;
          line-height: 19px;
        }

        .van-sku-header-item::after {
          content: "，";
          display: inline;
          line-height: 19px;
          // vertical-align: middle;
        }

        .header-show-selected-count {
          font-size: 13px;
          color: #999;
          line-height: 19px;
          margin-top: 8px;
        }
      }
    }

    ::v-deep .van-sku-body {
      .van-sku-row {
        margin-bottom: 25px;
      }

      .van-sku-row__title,
      .van-sku__stepper-title {
        font-size: 15px;
        font-weight: 500;
        color: #333333;
        line-height: 18px;
      }

      .van-sku-row__title {
        padding-bottom: 15px;
      }

      .van-sku-row__item {
        // height: 35px;
        background: #f5f5f5;
        border-radius: 18px;
        padding: 3px 10px;
        font-weight: 400;
        color: #333333;
        font-size: 13px;
        margin-bottom: 10px;
      }

      .van-sku-row__item::before {
        background: transparent;
      }

      .van-sku-row__item--active {
        border: 1px solid #4a79f1;
        color: #4a79f1;
        background: #fff;
      }

      .van-sku-stepper-stock {
        padding: 0;

        .van-stepper {
          // width: 86px;
          height: 22px;

          border-radius: 10px;
          padding: 0;
          border: 1px solid #cccccc;
          line-height: 20px;
          overflow: hidden;

          .van-stepper__minus,
          .van-stepper__plus {
            height: 20px;
            width: 24px;
            border-radius: 0;
            background: #fff;
            color: #333;
          }

          .van-stepper__minus--disabled {
            color: #dcdcdc;
          }

          .van-stepper__input {
            height: 20px;
            margin: 0;
            width: 38px;
            border-left: 2px solid #ccc;
            border-right: 2px solid #ccc;
            font-size: 14px;
            font-weight: 600;
            color: #333;

            background: #fff;
          }
        }
      }
    }

    ::v-deep .extra-tips {
      margin: 0 25px 18px 25px;
      font-weight: 400;
      color: #999999;
      line-height: 19px;
      font-size: 13px;
    }

    ::v-deep .van-sku-actions {
      button {
        height: 44px;
        background: #4a79f1;
        border-radius: 22px;
        font-weight: 500;
        color: #ffffff;
        line-height: 23px;
        font-size: 16px;
      }
    }
  }
  .hide-stepper {
    &::v-deep .van-sku-stepper-stock {
      display: none;
    }
  }
}
</style>
